import VoucherActiveManagement from "./voucher-active-management.page";

export default VoucherActiveManagement;
